import { forwardRef } from 'react'

import { Polymorphic } from '../../../utils/PolymorphicUtils'
import { Container } from '../../shared/container/container'
import { FooterContact } from './footer-contact'
import { FooterLinks } from './footer-links'
type FooterProps = {
  variant: 'full' | 'legal-only'
  headline: string
  overline: string
  image: string
  name: string
  email: string
  phone: string
}

export const Footer = forwardRef(function Footer(
  {
    as: Component = 'footer',
    variant,
    headline,
    overline,
    email,
    phone,
    name,
    image,
    ...props
  },
  ref,
) {
  const classNames = variant === 'full' ? 'pt-16 pb-6' : 'pt-6 pb-6'

  return (
    <Component
      className={`relative z-10 border-t border-ink-200/60 bg-white/80 px-6 dark:border-ink-800/80 dark:bg-ink-900/90 print:hidden ${classNames}`}
      {...props}
      ref={ref}
    >
      <Container className=" flex flex-col gap-12">
        {variant === 'full' && (
          <FooterContact
            headline={headline}
            overline={overline}
            image={image}
            name={name}
            email={email}
            phone={phone}
          />
        )}
        <FooterLinks />
      </Container>
    </Component>
  )
}) as Polymorphic<'footer', FooterProps>
